#
# Custom fields cloud in-place editor
#
class @CloudCustomFieldManager

  @setup: ->
    new @

  constructor: ->

    @toggleCustomField()
    @enableRearranging()
    @enableFieldDimming()
    @showAllFieldsInUseMessage()

  toggleCustomField: =>

    _this = this

    $(document).on "click", ".cloud-toggle-custom-field", ->

      $eventSource     = $(this)
      id               = $eventSource.data("custom-field-id")
      $activeEntry     = $(".cloud-custom-field-line[data-custom-field-id=#{id}]")
      $inactiveEntry   = $(".cloud-enable-custom-field[data-custom-field-id=#{id}]")
      wasActive        = $activeEntry.is(":visible")
      fn               = -> _this.showAllFieldsInUseMessage()
      $fields          = $(".form-fields input,textarea,select", $activeEntry)
      $confirmFalse    = $("li.web_forms_modify_subscriber_confirmation_required input[value='false']", $activeEntry)

      if wasActive # is inactive
        $confirmFalse.trigger("click")
        $fields.attr("disabled", "disabled")
        $activeEntry.slideUp(fn)
        $inactiveEntry.show()
      else # is active
        $fields.removeAttr("disabled")
        $activeEntry.slideDown(fn)
        $inactiveEntry.hide()

      return false

  enableRearranging: =>

    # Make the custom fields section arrangeable.
    $customFieldsContainer = $(".form-custom-fields .included-fields")
    $customFieldsContainer.arrangeable(".form-custom-field", "a.reorder-custom-field")
    $customFieldsContainer.on "click", "a.reorder-custom-field", ->
      Dialogs.presentModal
        header: t("modals.move_custom_field_option.header")
        body: t("modals.move_custom_field_option.body")
      return false

  enableFieldDimming: =>

    # Dim custom fields when they are hidden.
    adjustFieldDimness = ->
      $showOnFormRadio = $(@)
      $customFieldLine = $showOnFormRadio.closest(".form-custom-field")
      if $showOnFormRadio.is(":checked")
        if $showOnFormRadio.val() == "1"
          $customFieldLine.removeClass("dimmed")
        else
          $customFieldLine.addClass("dimmed")
    $customFieldsContainer = $(".form-custom-fields .included-fields")
    $customFieldLines      = $(".form-custom-field", $customFieldsContainer)
    $customFieldLines.each ->
      $customFieldLine  = $(@)
      $showOnFormRadios = $(".show_on_form", $customFieldLine)
      $showOnFormRadios.on "change", adjustFieldDimness
      $showOnFormRadios.each adjustFieldDimness

  showAllFieldsInUseMessage: ->

    # Show the "no fields are in use" message if there are no fields in use.
    $activeEntries = $(".included-fields .cloud-custom-field-line:visible")
    $noFieldsInUse = $(".no-fields-in-use")
    $noFieldsInUse.toggle($activeEntries.length == 0)

    # Show the "all fields are in use" message if there are no remaining buttons to activate.
    $inactiveEntries = $(".available-fields a.cloud-toggle-custom-field:visible")
    $fieldsAvailable = $(".fields-are-available")
    $allFieldsInUse  = $(".all-fields-in-use")
    $allFieldsInUse.toggle($inactiveEntries.length == 0)
    $fieldsAvailable.toggle($inactiveEntries.length != 0)

    return false
